import { render, staticRenderFns } from "./quyutoji.vue?vue&type=template&id=1788992c&scoped=true&"
import script from "./quyutoji.vue?vue&type=script&lang=js&"
export * from "./quyutoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788992c",
  null
  
)

export default component.exports